/**
 * Single Source of Truth fuer die Produkt-Import-Vorlage.
 * Deutscher Excel-Modus: Semikolon-Trenner, UTF-8 BOM.
 * Tag-Spalte heisst bewusst "Tags" (nicht "Kategorie"): der Header sagt dem
 * Haendler, dass Scoring-Tags hineingehoeren. Alt-Vorlagen mit "Kategorie"
 * bleiben importierbar (ALIAS_MAP im Backend, Rueckwaertskompatibilitaet).
 */
export const IMPORT_TEMPLATE_HEADER =
  "Artikelnummer;Artikelname;Produktlink;Produktbild;Preis;Tags;Beschreibung;Hersteller;UVP;Lagerbestand";

export const IMPORT_TEMPLATE_ROWS = [
  "SKU-001;Bio-Gesichtscreme 50ml;https://shop.de/creme;https://shop.de/img/creme.jpg;29,90;vegan,premium;Reichhaltige Pflege für empfindliche Haut;Dr. Hauschka;39,90;in_stock",
  "SKU-002;Vitamin C Serum 30ml;https://shop.de/serum;https://shop.de/img/serum.jpg;19,50;naturkosmetik,anti-aging;Anti-Aging Serum mit Vitamin C;Lavera;24,90;in_stock",
];

// UTF-8 BOM (U+FEFF) explizit ueber den Codepoint — kein unsichtbares Zeichen
// im Quelltext, damit es nicht still verloren geht oder mangelt.
const UTF8_BOM = String.fromCharCode(0xfeff);

export function buildTemplateCsv(): string {
  return `${UTF8_BOM}${IMPORT_TEMPLATE_HEADER}\n${IMPORT_TEMPLATE_ROWS.join("\n")}\n`;
}
